export default __webpack_public_path__ + "static/media/whiteShare.f8f0af2d.svg";